import { useMutation } from '@apollo/client';
import {
  DeferralReason,
  MarkClassEnrollmentAsDeferredDocument,
} from '@sandtech-hub-monorepo/ehub-client';
import React from 'react';
import { Button } from '@sandtech-hub-monorepo/ui-kit';
import { Loader2Icon } from 'lucide-react';
import { ReactComponent as DeferIcon } from '../../../assets/Icons/defer-icon.svg';
import { ProgramEnrollment } from './SelectProgram';

interface ConfirmProps {
  classEnrollmentIds: (string | undefined)[];
  description: string;
  reason: DeferralReason;
  onCancel: () => void;
  afterConfirm: () => void;
  alreadyDeferred: (string | undefined)[];
  programEnrollment: ProgramEnrollment;
}

export const DeferCourseConfirmation = ({
  description,
  reason,
  classEnrollmentIds,
  onCancel,
  afterConfirm,
  alreadyDeferred,
  programEnrollment,
}: ConfirmProps) => {
  const [mutate, { loading }] = useMutation(
    MarkClassEnrollmentAsDeferredDocument,
    {
      variables: {
        input: {
          classEnrollmentIds: classEnrollmentIds.filter(
            (id) => id !== undefined
          ) as string[],
          deferralDescription: description,
          deferralReason: reason,
        },
      },
      onCompleted: afterConfirm,
    }
  );

  return (
    <div className="max-w-[620px]">
      <div className="px-0 sm:px-16">
        <div className="flex flex-col items-center text-center gap-2">
          <div
            className={`p-6 bg-primary/20 rounded-full text-primary mx-auto mb-2`}
          >
            <DeferIcon height="48" width="48" />
          </div>
          <h2 className={`text-primary font-semibold sm:text-2xl text-xl`}>
            Please confirm
          </h2>
          <div className="text-xl">
            You are opting to defer the following course(s):
          </div>
        </div>
        <div className="border-b-primary/20 my-8 pb-8 border-b">
          <div className="text-center flex flex-col gap-2 mb-8">
            {programEnrollment.plannedCourses
              .filter(
                ({ enrollment }) =>
                  !alreadyDeferred.includes(enrollment?.currentClass?.id)
              )
              .map((course) => (
                <b key={course.id}>{course.details.name}</b>
              ))}
          </div>
          <div className="text-center">
            You will be enrolled in the next available class and will need to
            restart the course, completing all content from the beginning.
          </div>
        </div>
        <div className="flex gap-6 justify-center">
          <Button onClick={() => mutate()} disabled={loading}>
            {loading ? <Loader2Icon className="animate-spin" /> : 'Confirm'}
          </Button>
          <Button variant="outline" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};
